import { useState, useEffect } from 'react';

// Exports
/**
 * Can be used to delay the mounting of UI elements based on a timeout. If `skip: false`, the return
 * value of this hook will flip from `false` to `true` after `delayBy` milliseconds. If `skip: true`,
 * the return value will stay locked to `false`.
 */
export const useDelayReveal = (options: {
  skip: boolean;
  delayBy?: number;
}) => {
  const [revealed, setRevealed] = useState(false);
  useEffect(() => {
    if (!options.skip) {
      const timeoutId = setTimeout(
        () => setRevealed(true),
        options.delayBy ?? 300,
      );
      return () => {
        clearTimeout(timeoutId);
        setRevealed(false);
      };
    }
    return undefined;
  }, [options.delayBy, options.skip]);

  return revealed;
};
